import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const SubHeader = (props) => {
  const {
    children,
    className,
    small,
    medium,
    large,
    extraLarge,
    bgWhite,
    bgSemitransparent,
    flex,
    flexJustify,
    hideBorder,
    accordion,
    navigation,
    setMinHeight,
    ...restProps
  } = props;

  const computedClassName = classNames(
    {
      component: true,
      'component-sm': small,
      'component-md': medium,
      'component-lg': large,
      'component-xl': extraLarge,
      'component-bg-white': bgWhite,
      'component-bg-semitransparent': bgSemitransparent,
      flex: flex || flexJustify,
      'flex-justify': flexJustify,
      'flex-1': true,
      'component-hide-border': hideBorder,
      'component-accordion': accordion,
    },
    className
  );

  return (
    <div className="flex">
      <div
        className={computedClassName}
        style={{ minHeight: '60px' }}
        {...restProps}
      >
        {children}
      </div>
      {navigation}
    </div>
  );
};

SubHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  large: PropTypes.bool,
  extraLarge: PropTypes.bool,
  bgWhite: PropTypes.bool,
  bgSemitransparent: PropTypes.bool,
  flex: PropTypes.bool,
  flexJustify: PropTypes.bool,
  hideBorder: PropTypes.bool,
  navigation: PropTypes.node,
};

SubHeader.defaultProps = {
  small: false,
  large: false,
  medium: false,
  extraLarge: false,
  bgWhite: false,
  bgSemitransparent: false,
  flex: false,
  flexJustify: false,
  hideBorder: false,
};

export default SubHeader;
